import moment from 'moment';
import { bool, func, object, string, any } from 'prop-types';
import React, { Component } from 'react';
import Datetime from 'react-datetime';

import i18n from 'utils/translate';
import './styles.scss';

const propTypes = {
  className: string,
  inputClassName: string,
  maxDate: object,
  minDate: object,
  onChange: func.isRequired,
  onWrongDate: func,
  placeholder: string,
  required: bool,
  value: any
};

const defaultProps = {
  className: '',
  inputClassName: '',
  placeholder: i18n('TT.MM.JJJJ'),
  required: false,
  value: undefined
};

class Datepicker extends Component {
  dateInPast = false;
  dateInFuture = false;

  constructor(props) {
    super(props);

    this.state = {
      value: props.value
    };
  }

  componentDidUpdate = prevProps => {
    if (prevProps.value !== this.props.value) {
      let value = this.props.value;

      if (this.props.value && !moment.isMoment(this.props.value)) {
        value = moment(this.props.value);
      }

      this.setState({ value });
    }
  };

  renderInput = (props, openCalendar) => {
    const inputProps = { ...props };
    delete inputProps.onClick;
    delete inputProps.onFocus;

    return (
      <div>
        <input {...inputProps} />
        <div className="calendar-icon" onClick={openCalendar} />
      </div>
    );
  };

  isValidDate = currentDate => {
    const { maxDate, minDate } = this.props;
    const pickerProps = {
      maxDate: moment.isMoment(maxDate) && maxDate.isValid() ? maxDate : undefined,
      minDate: moment.isMoment(minDate) && minDate.isValid() ? minDate : undefined
    };
    let isValid = true;

    if (pickerProps.maxDate && !currentDate.isBefore(pickerProps.maxDate)) {
      isValid = false;
      this.dateInFuture = true;
      this.dateInPast = false;
    } else if (pickerProps.minDate && !currentDate.isAfter(pickerProps.minDate)) {
      isValid = false;
      this.dateInFuture = false;
      this.dateInPast = true;
    } else {
      this.dateInFuture = false;
      this.dateInPast = false;
    }

    return isValid;
  };

  formatToValidDateFormat = value => {
    let sanitizedValue = value;

    if (moment(value, 'D.M.YYYY', true).isValid()) {
      sanitizedValue = moment(value, 'DD.MM.YYYY');
      sanitizedValue = moment(sanitizedValue.format('DD.MM.YYYY'), 'DD.MM.YYYY');
    }

    return sanitizedValue;
  };

  onInputBlur = () => {
    let { value } = this.state;
    const { onWrongDate, onBlur } = this.props;
    let sanitizedValue = this.formatToValidDateFormat(value);

    if (moment.isMoment(sanitizedValue) && sanitizedValue.isValid() && this.isValidDate(sanitizedValue)) {
      if (onWrongDate) {
        onWrongDate(null);
      }
    } else {
      // We don't update onWrongDate with undefined, so we can keep the previous customError message
      // instead switching to 'Eingabe erforderlich' because value is undefined
      if (onWrongDate && sanitizedValue) {
        onWrongDate(sanitizedValue, this.dateInPast, this.dateInFuture);
      }
    }

    if (onBlur) {
      onBlur(sanitizedValue);
    }
  };

  onChangeDate = value => {
    const { onChange } = this.props;
    let sanitizedValue = this.formatToValidDateFormat(value);

    this.setState({ value: sanitizedValue }, () => {
      if (moment.isMoment(sanitizedValue) && sanitizedValue.isValid() && this.isValidDate(sanitizedValue)) {
        onChange(sanitizedValue);
      } else {
        onChange(undefined);
      }
    });
  };

  render() {
    const { className, inputClassName, placeholder, required, dateFormat } = this.props;

    const pickerProps = {
      className,
      closeOnSelect: true,
      inputProps: {
        className: inputClassName,
        onBlur: this.onInputBlur,
        placeholder,
        required
      },
      isValidDate: this.isValidDate,
      locale: 'de',
      onOpen: this.onInputBlur,
      onChange: value => this.onChangeDate(value),
      renderInput: this.renderInput,
      timeFormat: false,
      value: this.state.value,
      dateFormat
    };

    return <Datetime {...pickerProps} />;
  }
}

Datepicker.propTypes = propTypes;
Datepicker.defaultProps = defaultProps;

export default Datepicker;
